module.exports = __webpack_public_path__ + "img/td-icon5.a5e3e045.png";